import ApiBlockNavigation from "../ApiBlockNavigation";
import { Outlet, useLocation } from "react-router-dom";
import ApiRequestLanguages from "../ApiRequestLanguages";
import { useApiPageContext } from "context/ApiPagecontext";
import { useEffect } from "react";

const ApiBlockLayout = () => {
  const pathname = useLocation().pathname;
  const { setSelectedEndpoint } = useApiPageContext();

  useEffect(() => {
    if (pathname.includes("endpoints")) {
      const endpointNameByPath = pathname.split("/").pop();
      setSelectedEndpoint(endpointNameByPath);
    }
  }, [pathname, setSelectedEndpoint]);

  return (
    <div className="api-block-layout">
      <ApiBlockNavigation />
      <div className="api-block-layout-outlet">
        {pathname.includes("endpoints") && <ApiRequestLanguages />}
        <Outlet />
      </div>
    </div>
  );
};

export default ApiBlockLayout;
